module.exports = __webpack_public_path__ + "img/borderLineWhite.8d2d7c21.svg";